import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './TitleWithDescription.css';

const TitleWithDescription = (props) => {
    if (!props.title) return null;
    const { title, rightText, borderLine } = props;
    return (
        <div>
            <div
                id={props.id}
                className={cn('header', {
                    withdate: !!rightText,
                    border: borderLine
                })}
            >
                {title && <h2>{title}</h2>}
                {rightText && (
                    <div className="date">{rightText(rightText)}</div>
                )}
            </div>
            <div
                className={cn({
                    content: !!props.children
                })}
            >
                {props.children}
            </div>

            <style jsx>{styles}</style>
        </div>
    );
};

TitleWithDescription.defaultProps = {
    title: '',
    id: '',
    rightText: null
};

TitleWithDescription.propTypes = {
    /**
     * Title of the card
     */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    /**
     * ID for the card
     */
    id: PropTypes.string,
    /**
     * Right text of the card (i.e - As of date)
     */
    rightText: PropTypes.func
};

export default TitleWithDescription;

// make this take a child component to make content sections
